// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../types.schema';

export const engineQueueStatsItemSchema = z.object({
  url: urlSchema,
  numberOfUsedEngineFields: z.number(),
  predictionQueue: z.boolean(),
  trainingQueue: z.boolean(),
});
